<template>
  <div class="products-page">
    <Header :active-nav="activeNav" @nav-click="handleNavClick" />

    <main class="main-content">
      <div class="products-section">
        <div class="container">
          <div v-if="activeProducts.length" class="active-series">
            <div class="series-header">
              <h2 class="series-title">
                {{ activeSeriesName }}
              </h2>
            </div>

            <div class="products-grid">
              <div
                  v-for="product in activeProducts"
                  :key="product.id"
                  class="product-card"
              >
                <div class="product-image">
                  <img :src="product.image" :alt="product.title" />
                </div>
                <div class="product-info">
                  <h3 class="product-title">{{ product.title }}</h3>
                  <div class="product-tags">
                    <span
                        v-for="tag in product.tags"
                        :key="tag"
                        class="product-tag"
                    >
                      {{ tag }}
                    </span>
                  </div>
                  <p class="product-desc">{{ product.shortDescription }}</p>
                </div>
              </div>
            </div>
          </div>

          <div v-for="series in otherSeries" :key="series.id" class="other-series">
            <div class="series-header">
              <h2 class="series-title">
                {{ series.name }}
              </h2>
            </div>

            <div class="products-grid compact">
              <div
                  v-for="product in getProductsBySeries(series.id)"
                  :key="product.id"
                  class="product-card compact"
              >
                <div class="product-image">
                  <img :src="product.image" :alt="product.title" />
                </div>
                <div class="product-info">
                  <h3 class="product-title">{{ product.title }}</h3>
                  <div class="product-tags">
                    <span
                        v-for="tag in product.tags"
                        :key="tag"
                        class="product-tag"
                    >
                      {{ tag }}
                    </span>
                  </div>
                  <p class="product-desc">{{ product.shortDescription }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Footer @scroll-to="handleScrollTo" @show-product="handleShowProduct" />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Products',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      activeNav: 'products',
      activeSeries: '',
      seriesList: [
        { id: 'beef-jerky', name: '牛肉干系列' },
        { id: 'pork-jerky', name: '猪肉脯系列' },
        { id: 'snacks', name: '休闲零食系列' },
        { id: 'cashew', name: '坚果系列' },
        { id: 'gift-box', name: '礼盒系列' },
        { id: 'cultural', name: '文创系列' }
      ],
      products: [
        // 猪肉脯系列产品
        {
          id: 1,
          series: 'pork-jerky',
          title: '脆脆猪肉脯',
          tags: ['酥脆', '非油炸'],
          shortDescription: '脆如薯片，香过油渣',
          image: require(`@/assets/product/all/1/1.jpg`),
          isNew: true
        },
        {
          id: 2,
          series: 'pork-jerky',
          title: '特级原切猪肉脯',
          tags: ['特级', '原切'],
          shortDescription: '特级品质,大片耐嚼',
          image: require(`@/assets/product/all/1/2.jpg`),
          isNew: false
        },
        {
          id: 3,
          series: 'pork-jerky',
          title: '蜜汁黑椒猪肉脯',
          tags: ['黑椒', '蜜汁'],
          shortDescription: '咸鲜带甜,肉感十足',
          image: require(`@/assets/product/all/1/3.jpg`),
          isNew: false
        },
        {
          id: 10,
          series: 'pork-jerky',
          title: '川川猪肉脯',
          tags: ['川香', '耐嚼'],
          shortDescription: '地道川香，层层入味',
          image: require(`@/assets/product/all/1/4.jpg`),
          isNew: true
        },
        {
          id: 16,
          series: 'pork-jerky',
          title: '墩墩猪肉粒',
          tags: ['鲜香', '耐嚼'],
          shortDescription: '大粒原切，十足嚼劲',
          image: require(`@/assets/product/all/1/03墩墩猪肉粒.jpg`),
          isNew: true
        },
        {
          id: 17,
          series: 'pork-jerky',
          title: '原切猪肉片',
          tags: ['原切', '耐嚼'],
          shortDescription: '整片原切，风味浓郁',
          image: require(`@/assets/product/all/1/04原切猪肉片.jpg`),
          isNew: true
        },
        {
          id: 18,
          series: 'pork-jerky',
          title: '酥酥猪肉松条',
          tags: ['酥脆', '鲜香'],
          shortDescription: '松香酥脆，鲜香四溢',
          image: require(`@/assets/product/all/1/12酥酥猪肉松条.jpg`),
          isNew: true
        },
        // 牛肉干系列
        {
          id: 4,
          series: 'beef-jerky',
          title: '古法卤牛肉干',
          tags: ['湿软', '易嚼'],
          shortDescription: '先卤后烤，手撕大片',
          image: require(`@/assets/product/all/4/1.jpg`),
          isNew: true
        },
        {
          id: 5,
          series: 'beef-jerky',
          title: '芝香牛肉干',
          tags: ['芝香', '油润'],
          shortDescription: '芝香浓郁，油润耐嚼',
          image: require(`@/assets/product/all/4/2.jpg`),
          isNew: false
        },
        {
          id: 11,
          series: 'beef-jerky',
          title: '汁汁卤牛肉',
          tags: ['多汁', '鲜香'],
          shortDescription: '汁水丰富，鲜香撩舌',
          image:require(`@/assets/product/all/4/3.jpg`),
          isNew: true
        },
        {
          id: 31,
          series: 'beef-jerky',
          title: '绵绵牛肉干',
          tags: ['绵软', '易嚼'],
          shortDescription: '绵绵口感，丝丝入味',
          image:require(`@/assets/product/all/4/4.jpg`),
          isNew: true
        },
        {
          id: 32,
          series: 'beef-jerky',
          title: '奇趣手撕牛肉',
          tags: ['手撕', '紧实'],
          shortDescription: '手撕过瘾，紧实耐嚼',
          image:require(`@/assets/product/all/4/5.jpg`),
          isNew: true
        },
        {
          id: 33,
          series: 'beef-jerky',
          title: '小傲娇牛肉干',
          tags: ['椒麻', '易嚼'],
          shortDescription: '藤椒风味，清新诱人',
          image:require(`@/assets/product/all/4/6.jpg`),
          isNew: true
        },
        {
          id: 34,
          series: 'beef-jerky',
          title: '弹弹牛板筋',
          tags: ['弹韧', '爽滑'],
          shortDescription: 'Q弹爽滑，柔韧入味',
          image:require(`@/assets/product/all/4/07弹弹牛板筋.jpg`),
          isNew: true
        },
        {
          id: 35,
          series: 'beef-jerky',
          title: '火火辣牛肉',
          tags: ['香辣', '油润'],
          shortDescription: '销魂香辣，酣畅过瘾',
          image:require(`@/assets/product/all/4/08火火辣牛肉.jpg`),
          isNew: true
        },
        {
          id: 36,
          series: 'beef-jerky',
          title: '糯糯牛筋肉',
          tags: ['软糯', 'Q弹'],
          shortDescription: '筋肉相间，双重口感',
          image:require(`@/assets/product/all/4/09糯糯牛筋肉.jpg`),
          isNew: true
        },
        {
          id: 37,
          series: 'beef-jerky',
          title: '轻享卤牛肉',
          tags: ['鲜香', '入味'],
          shortDescription: '真材食卤,鲜香本味',
          image:require(`@/assets/product/all/4/10轻享卤牛肉.jpg`),
          isNew: true
        },
        {
          id: 37,
          series: 'beef-jerky',
          title: '酱牛肉',
          tags: ['酱香', '入味'],
          shortDescription: '大块整切，酱香十足',
          image:require(`@/assets/product/all/4/11酱牛肉.jpg`),
          isNew: true
        },
        {
          id: 38,
          series: 'beef-jerky',
          title: '风琴牛肉干',
          tags: ['大片', '易嚼'],
          shortDescription: '卤香四溢，丝丝入味',
          image:require(`@/assets/product/all/4/12风琴牛肉干.jpg`),
          isNew: true
        },
        {
          id: 39,
          series: 'beef-jerky',
          title: '魔方卤牛肉',
          tags: ['整切', '鲜嫩'],
          shortDescription: '慢卤入味，鲜美多汁',
          image:require(`@/assets/product/all/4/13魔方卤牛肉.jpg`),
          isNew: true
        },
        {
          id: 40,
          series: 'beef-jerky',
          title: '鲜鲜卤牛腱',
          tags: ['整切', '嚼劲'],
          shortDescription: '酱卤原香,筋肉相连',
          image:require(`@/assets/product/all/4/14鲜鲜卤牛腱.jpg`),
          isNew: true
        },
        {
          id: 41,
          series: 'beef-jerky',
          title: '轻炙·原切牛肉片',
          tags: ['炙烤', '原切'],
          shortDescription: '轻炙慢烤，嚼劲十足',
          image:require(`@/assets/product/all/4/15轻炙·原切牛肉片.jpg`),
          isNew: true
        },
        {
          id: 42,
          series: 'beef-jerky',
          title: '原切牛肉条',
          tags: ['原切', '香浓'],
          shortDescription: '原切成条，肉味醇正',
          image:require(`@/assets/product/all/4/16原切牛肉条.jpg`),
          isNew: true
        },
        {
          id: 43,
          series: 'beef-jerky',
          title: '咔嚓牛排脆',
          tags: ['轻薄', '酥脆'],
          shortDescription: '轻薄酥脆，奶香醇正',
          image:require(`@/assets/product/all/4/17.png`),
          isNew: true
        },

        // 休闲零食系列
        {
          id: 6,
          series: 'snacks',
          title: 'QQ卤蛋',
          tags: ['卤味', 'Q弹'],
          shortDescription: '老火慢卤,Q弹爽口',
          image: require(`@/assets/product/all/5/2.jpg`),
          isNew: true
        },
        {
          id: 12,
          series: 'snacks',
          title: '低糖黑芝麻丸',
          tags: ['低糖', '软糯'],
          shortDescription: '软糯清甜，营养丰富',
          image: require(`@/assets/product/all/5/1.jpg`),
          isNew: false
        },
        {
          id: 19,
          series: 'snacks',
          title: '托塔小饼干',
          tags: ['酥软', '香浓'],
          shortDescription: '松软可口，营养均衡',
          image: require(`@/assets/product/all/5/05托塔小饼干.jpg`),
          isNew: false
        },
        {
          id: 20,
          series: 'snacks',
          title: '糯叽叽梅饼',
          tags: ['酸甜', '软糯'],
          shortDescription: '皮薄肉厚，酸甜清爽',
          image: require(`@/assets/product/all/5/06糯叽叽梅饼.jpg`),
          isNew: false
        },
        {
          id: 21,
          series: 'snacks',
          title: '浮云牛轧奶酥',
          tags: ['奶香', '拉丝'],
          shortDescription: '奶香浓郁，酥软拉丝',
          image: require(`@/assets/product/all/5/07浮云牛轧奶酥.jpg`),
          isNew: false
        },
        {
          id: 22,
          series: 'snacks',
          title: '爆爆肉弹肠',
          tags: ['肉感', '爆汁'],
          shortDescription: '肉感十足，弹脆爆汁',
          image: require(`@/assets/product/all/5/08爆爆肉弹肠.jpg`),
          isNew: false
        },
        {
          id: 23,
          series: 'snacks',
          title: '玉米花系列',
          tags: ['奶香', '酥脆'],
          shortDescription: '颗颗酥脆，奶香四溢',
          image: require(`@/assets/product/all/5/09玉米花系列.jpg`),
          isNew: false
        },

        {
          id: 24,
          series: 'snacks',
          title: '脆脆肉脯',
          tags: ['酥脆', '鲜香'],
          shortDescription: '脆如薯片，香过油渣',
          image: require(`@/assets/product/all/5/10脆脆肉脯.jpg`),
          isNew: false
        },
        {
          id: 25,
          series: 'snacks',
          title: '蜜汁鸭翅根',
          tags: ['蜜汁', '浓郁'],
          shortDescription: '个大肉厚，甜蜜浓汁',
          image: require(`@/assets/product/all/5/11蜜汁鸭翅根.jpg`),
          isNew: false
        },
        {
          id: 26,
          series: 'snacks',
          title: '咔嚓鸡排脆',
          tags: ['薄脆', '鲜香'],
          shortDescription: '片片香脆，越嚼越香',
          image: require(`@/assets/product/all/5/15咔嚓鸡排脆.jpg`),
          isNew: false
        },
        {
          id: 26,
          series: 'snacks',
          title: '黄鱼酥',
          tags: ['酥脆', '鲜香'],
          shortDescription: '酥若无骨，鲜香可口',
          image: require(`@/assets/product/all/5/17.jpg`),
          isNew: false
        },

        // 腰果系列
        {
          id: 7,
          series: 'cashew',
          title: '紫衣腰果',
          tags: ['原香', '酥脆'],
          shortDescription: '自然本味，颗颗饱满',
          image: require(`@/assets/product/all/6/1.jpg`),
          isNew: false
        },
        {
          id: 13,
          series: 'cashew',
          title: '太丰腰果',
          tags: ['原香', '饱满'],
          shortDescription: '原香原味，粒大酥脆',
          image: require(`@/assets/product/all/6/2.jpg`),
          isNew: true
        },
        {
          id: 27,
          series: 'cashew',
          title: '金衣腰果',
          tags: ['酥脆', '醇香'],
          shortDescription: '外酥里脆，醇香可口',
          image: require(`@/assets/product/all/6/13金衣腰果.jpg`),
          isNew: true
        },
        {
          id: 28,
          series: 'cashew',
          title: '陈皮瓜子',
          tags: ['清新', '易嗑'],
          shortDescription: '陈皮清新，皮薄易嗑',
          image: require(`@/assets/product/all/6/14陈皮瓜子.jpg`),
          isNew: true
        },
        {
          id: 29,
          series: 'cashew',
          title: '黄瓜味腰果',
          tags: ['清新', '酥脆'],
          shortDescription: '甄选优果，清爽酥脆',
          image: require(`@/assets/product/all/6/16黄瓜味腰果.jpg`),
          isNew: true
        },
        // 礼盒系列
        {
          id: 8,
          series: 'gift-box',
          title: '太丰端午礼盒',
          tags: ['端午', '佳礼'],
          shortDescription: '端午臻礼，粽情端午',
          image: require(`@/assets/product/all/2/1.png`),
          isNew: true
        },
        {
          id: 14,
          series: 'gift-box',
          title: '太丰中秋礼盒',
          tags: ['中秋', '佳礼'],
          shortDescription: '恣意中秋，铭心佳礼',
          image: require(`@/assets/product/all/2/2.jpg`),
          isNew: false
        },
        {
          id: 30,
          series: 'gift-box',
          title: '太丰食趣礼盒',
          tags: ['新年', '佳礼'],
          shortDescription: '食中之趣，不亦说乎',
          image: require(`@/assets/product/all/2/03太丰食趣礼盒食中之趣，不亦说乎.jpg`),
          isNew: false
        },

        // 文创系列
        {
          id: 9,
          series: 'cultural',
          title: '太丰·满电随行礼盒',
          tags: ['水杯', '充电宝'],
          shortDescription: '能量满满，自在随行',
          image: require(`@/assets/product/all/3/1.jpg`),
          isNew: false
        },
        {
          id: 15,
          series: 'cultural',
          title: '太丰·知食份子帆布袋',
          tags: ['文创', '包袋'],
          shortDescription: '知食分子，自在随行',
          image: require(`@/assets/product/all/3/2.jpg`),
          isNew: true
        },
        {
          id: 44,
          series: 'cultural',
          title: '太丰·丰味知礼礼盒',
          tags: ['钢笔', '杯子', '冰箱贴'],
          shortDescription: '提笔食光，捧杯朝夕',
          image: require(`@/assets/product/all/3/3.png`),
          isNew: true
        },
      ]
    }
  },
  computed: {
    activeSeriesName() {
      const series = this.seriesList.find(s => s.id === this.activeSeries)
      return series ? series.name : ''
    },
    activeProducts() {
      return this.products.filter(product => product.series === this.activeSeries)
    },
    otherSeries() {
      return this.seriesList.filter(series => series.id !== this.activeSeries)
    }
  },
  created() {
    // 从URL参数获取系列
    this.updateActiveSeriesFromUrl()
  },
  mounted() {
    // 每次进入页面时滚动到顶部
    window.scrollTo(0, 0)
  },
  watch: {
    // 监听路由变化
    '$route'(to, from) {
      // 如果路由变化（比如从其他页面跳转过来），重新获取参数
      if (to.name === 'Products') {
        this.updateActiveSeriesFromUrl()
        // 滚动到顶部
        window.scrollTo(0, 0)
      }
    }
  },
  methods: {
    handleNavClick(sectionId) {
      if (sectionId === 'home') {
        this.$router.push({ name: 'Home', hash: `#${sectionId}` })
      } else {
        this.$router.push({ name: sectionId.charAt(0).toUpperCase() + sectionId.slice(1) })
      }
    },
    handleScrollTo(sectionId) {
      if (this.$route.name === 'Home') {
        const element = document.getElementById(sectionId)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      } else {
        this.$router.push({ name: 'Home', hash: `#${sectionId}` })
      }
    },
    handleShowProduct(id) {
      this.$router.push({ name: 'ProductDetail', params: { id } })
    },
    getProductsBySeries(seriesId) {
      //return this.products.filter(product => product.series === seriesId).slice(0, 4)
      return this.products.filter(product => product.series === seriesId)

    },
    updateActiveSeriesFromUrl() {
      // 从URL中获取seriesId参数
      console.log('完整的params对象:', this.$route.params)
      console.log('完整的query对象:', this.$route.query)
      console.log('完整的path:', this.$route.path)


      const path = this.$route.path
      console.log('当前path:', path)

      // 解析 /product/gift-box 这样的路径
      const match = path.match(/\/product\/([^\/?]+)/)

      let seriesId = ''
      if (match && match[1]) {
        seriesId = match[1]
        console.log('从path解析到的seriesId:', seriesId)
      }
      console.log('URL参数:', seriesId) // 调试用
      if (seriesId && this.seriesList.some(s => s.id === seriesId)) {
        this.activeSeries = seriesId
      } else {
        // 如果URL中没有有效seriesId，默认显示第一个系列
        this.activeSeries = this.seriesList[0]?.id || ''
      }
      console.log('激活的系列:', this.activeSeries) // 调试用
    }
  }
}
</script>

<style scoped>
.products-page {
  background: #ffffff;
  color: #333333;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.main-content {
  padding-top: 80px;
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.series-header {
  margin-bottom: 2.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e9ecef;
}

.active-series .series-header {
  margin-top: 3rem;
  border-bottom-color: #9e1317;
}

.series-title {
  font-size: 2.2rem;
  color: #222222;
  margin: 0;
  font-weight: 700;
  position: relative;
  padding-left: 1.5rem;
}

.series-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 32px;
  background: linear-gradient(135deg, #9e1317, #b81c22);
  border-radius: 4px;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 2rem;
  margin-bottom: 4rem;
}

.products-grid.compact {
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1.8rem;
  margin-bottom: 3rem;
}

.product-card {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border: 1px solid #e0e0e0;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.product-card:hover {
  transform: translateY(-8px);
  border-color: #9e1317;
  box-shadow: 0 12px 30px rgba(158, 19, 23, 0.12);
}

.product-card.compact:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(158, 19, 23, 0.1);
}

.product-image {
  position: relative;
  height: 200px;
  overflow: hidden;
  background: #f8f9fa;
}

.product-card.compact .product-image {
  height: 180px;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.product-card:hover .product-image img {
  transform: scale(1.08);
}

.product-badge {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: #9e1317;
  color: #ffffff;
  padding: 0.4rem 0.8rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(158, 19, 23, 0.3);
}

.product-info {
  padding: 1.8rem;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.product-card.compact .product-info {
  padding: 1.5rem;
}

.product-title {
  font-size: 1.4rem;
  color: #222222;
  margin: 0 0 1rem;
  font-weight: 600;
  line-height: 1.3;
}

.product-card.compact .product-title {
  font-size: 1.2rem;
  margin-bottom: 0.75rem;
}

.product-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.product-tag {
  background: rgba(158, 19, 23, 0.08);
  color: #9e1317;
  padding: 0.3rem 0.8rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 500;
  border: 1px solid rgba(158, 19, 23, 0.2);
}

.product-desc {
  color: #666666;
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0;
  flex: 1;
}

.product-card.compact .product-desc {
  font-size: 0.85rem;
  color: #777777;
}

@media (max-width: 1024px) {
  .products-grid {
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  }

  .products-grid.compact {
    grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  }

  .series-title {
    font-size: 1.8rem;
  }
}

@media (max-width: 768px) {
  .main-content {
    padding-top: 70px;
  }

  .series-title {
    font-size: 1.6rem;
  }

  .products-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 1.5rem;
  }

  .products-grid.compact {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 1.2rem;
  }
}

@media (max-width: 576px) {
  .container {
    padding: 0 1rem;
  }

  .products-grid {
    grid-template-columns: 1fr;
    gap: 1.2rem;
  }

  .products-grid.compact {
    grid-template-columns: 1fr;
  }

  .series-title {
    font-size: 1.4rem;
  }

  .product-image {
    height: 180px;
  }

  .product-card.compact .product-image {
    height: 160px;
  }

  .product-info {
    padding: 1.2rem;
  }
}
</style>